// extracted by mini-css-extract-plugin
module.exports = {"specWrap":"style_specWrap__GRFGM","blue":"style_blue__APkrA","grid":"style_grid__KTU_9","text":"style_text__zOFw0","table":"style_table__Tdszv","cell":"style_cell__56oWZ"};